import React from "react";
import ReactDOM from "react-dom/client";
import { z } from "zod";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import { createStore } from "redux";
import { Provider } from "react-redux";
import authReducer from "./redux/authReducer";
import { schemas } from "./api/generated";

// Import our custom CSS
import "./css/styles.scss";

// Import all of Bootstrap's JS
import "bootstrap";

const UserTypeSchema = schemas.UserType;

// Migrate token from localStorage to sessionStorage if it exists in localStorage
const legacyTokenData = window.localStorage.getItem("token");
if (legacyTokenData) {
  window.sessionStorage.setItem("token", legacyTokenData);
  window.localStorage.removeItem("token");
}

const storedTokenData = window.sessionStorage.getItem("token");

const TokenDataSchema = z.object({
  token: z.string(),
  user: z.object({
    id: z.string(),
    email: z.string(),
    userType: z.union([z.literal("Admin"), z.literal("User")]),
  }),
});

const currentUser =
  storedTokenData != null &&
  (await TokenDataSchema.parseAsync(JSON.parse(storedTokenData))
    .then((json) => ({
      token: json.token,
      id: json.user.id,
      userType: UserTypeSchema.parse(json.user.userType),
    }))
    .catch(() => null));

const initialState = currentUser
  ? { isLoggedIn: true, currentUser }
  : { isLoggedIn: false, currentUser: null };

const store = createStore(
  authReducer,
  initialState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error("Root element '#root' was not found.");
  throw new Error("Root element not found");
}
const root = ReactDOM.createRoot(rootElement);

const ConditionalStrictMode =
  // change the following line to work for vite enviroment variable
  import.meta.env.VITE_REACT_APP_COVERAGE === "true"
    ? React.Fragment
    : React.StrictMode;

root.render(
  <ConditionalStrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </ConditionalStrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
